import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch all documents
export const fetchAllDocuments = createAsyncThunk(
    'documents/fetchAllDocuments',
    async (_, { rejectWithValue }) => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 1000)); // Force delay
            const response = await axios.get('api/v1/get_all_documents');
            return response.data.documents || [];
        } catch (err) {
            console.error('Failed to fetch documents:', err);
            return rejectWithValue(err.response?.data || 'Unknown error');
        }
    }
);

const documentsSlice = createSlice({
    name: 'documents',
    initialState: {
        allDocuments: [],
        loading: false,
        error: null,
    },
    reducers: {
        setAllDocuments(state, action) {
            state.allDocuments = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllDocuments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllDocuments.fulfilled, (state, action) => {
                state.loading = false;
                state.allDocuments = action.payload;
            })
            .addCase(fetchAllDocuments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setAllDocuments } = documentsSlice.actions;
export default documentsSlice.reducer;
